/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".feedback[_ngcontent-%COMP%]{margin-top:1.5rem;padding:0 0 0 1.5rem;list-style-type:square}.feedback[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:.2rem 0}.feedback-warning[_ngcontent-%COMP%]{color:#a94442}.feedback-suggestion[_ngcontent-%COMP%]{color:#818a91}\n/*# sourceMappingURL=password-feedback.component.css.map*/"];
export { styles as styles };
